import { requestProductUse } from "@/lib/entitlement/entitlementRequest";
import { getUsableEntitlement } from "./entitlement";
/**
 * 상품의 다운로드 가능 여부를 판별
 *
 * 우선순위:
 * 1. 낙관적 업데이트된 라이센스 (download 플랜)
 * 2. 서버 보유 라이센스 (download 플랜)
 * 3. 이용 수단(이용권/구독)으로 다운로드 획득 가능
 */ export const getDownloadAvailability = (product, acquiredLicenseInfo)=>{
    var _product_purchaseOptions;
    // 1. 낙관적 업데이트된 라이센스
    if ((acquiredLicenseInfo === null || acquiredLicenseInfo === void 0 ? void 0 : acquiredLicenseInfo.licensePlan) === "download") {
        return {
            available: true,
            hasLicense: true
        };
    }
    // 2. 서버 보유 라이센스
    if (product.licenseId && product.licensePlan === "download") {
        return {
            available: true,
            hasLicense: true
        };
    }
    // 3. 이용 수단으로 다운로드 획득 가능
    if (getUsableEntitlement(product) && ((_product_purchaseOptions = product.purchaseOptions) === null || _product_purchaseOptions === void 0 ? void 0 : _product_purchaseOptions.includes("download"))) {
        return {
            available: true,
            hasLicense: false
        };
    }
    return {
        available: false,
        hasLicense: false
    };
};
/**
 * 이용 수단(이용권/구독)으로 다운로드 라이센스를 획득 (순수 API 호출)
 * @returns licenseId 또는 null
 */ export const acquireDownloadLicense = async (productId, entitlement)=>{
    var _response_licenseIds;
    const response = await requestProductUse({
        productIds: [
            productId
        ],
        entitlement,
        choicePurchaseOption: "download"
    });
    var _response_licenseIds_;
    return (_response_licenseIds_ = (_response_licenseIds = response.licenseIds) === null || _response_licenseIds === void 0 ? void 0 : _response_licenseIds[0]) !== null && _response_licenseIds_ !== void 0 ? _response_licenseIds_ : null;
};
